import { useState } from 'react'
import { MenuIcon, XIcon, LogoutIcon } from '@heroicons/react/outline'
import useAuth from 'hooks/useAuth'
import { useNavigate, useLocation } from 'react-router-dom'

const Header = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { isAuth, logout } = useAuth()
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const handleLogout = () => {
    logout()
    navigate('/')
    setMobileMenuOpen(false)
  }

  const isActive = (path: string) => location.pathname.startsWith(path)

  const navLinks = [
    { name: 'Dashboard', path: '/dashboard' },
    { name: 'Send Money', path: '/payment' },
    { name: 'Top Up', path: '/topup/enter-amount' },
  ]

  return (
    <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-lg border-b border-neutral-200/60">
      <div className="page-container">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault()
              navigate(isAuth() ? '/dashboard' : '/')
            }}
            className="flex items-center gap-2"
          >
            <div className="w-10 h-10 rounded-xl gradient-primary flex items-center justify-center">
              <span className="text-white font-bold text-lg">S</span>
            </div>
            <span className="hidden sm:block font-semibold text-lg text-neutral-800">
              Stablecoin Remittance Demo
            </span>
          </a>

          {isAuth() && (
            <nav className="hidden md:flex items-center gap-1">
              {navLinks.map((link) => (
                <a
                  key={link.path}
                  href="#"
                  onClick={(e) => {
                    e.preventDefault()
                    navigate(link.path)
                  }}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                    isActive(link.path)
                      ? 'bg-primary-50 text-primary-600'
                      : 'text-neutral-600 hover:text-neutral-900 hover:bg-neutral-100'
                  }`}
                >
                  {link.name}
                </a>
              ))}
            </nav>
          )}

          <div className="flex items-center gap-3">
            {isAuth() && (
              <>
                <button
                  onClick={handleLogout}
                  className="hidden md:flex btn-ghost btn-sm"
                >
                  <LogoutIcon className="w-5 h-5" />
                  <span>Logout</span>
                </button>

                <button
                  onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                  className="md:hidden p-2 rounded-lg hover:bg-neutral-100 transition-colors"
                >
                  {mobileMenuOpen ? (
                    <XIcon className="w-6 h-6 text-neutral-600" />
                  ) : (
                    <MenuIcon className="w-6 h-6 text-neutral-600" />
                  )}
                </button>
              </>
            )}
          </div>
        </div>
      </div>

      {mobileMenuOpen && isAuth() && (
        <div className="md:hidden absolute top-full left-0 right-0 bg-white border-b border-neutral-200 shadow-lg animate-slide-up">
          <div className="page-container py-4 space-y-2">
            {navLinks.map((link) => (
              <a
                key={link.path}
                href="#"
                onClick={(e) => {
                  e.preventDefault()
                  navigate(link.path)
                  setMobileMenuOpen(false)
                }}
                className={`block px-4 py-3 rounded-xl text-base font-medium transition-colors ${
                  isActive(link.path)
                    ? 'bg-primary-50 text-primary-600'
                    : 'text-neutral-600 hover:bg-neutral-100'
                }`}
              >
                {link.name}
              </a>
            ))}
            <button
              onClick={handleLogout}
              className="w-full flex items-center gap-2 px-4 py-3 rounded-xl text-base font-medium text-error-600 hover:bg-error-50 transition-colors"
            >
              <LogoutIcon className="w-5 h-5" />
              Logout
            </button>
          </div>
        </div>
      )}
    </header>
  )
}

export default Header
